import { Button, LoadingSkeleton, Row } from "@narmi/design_system";
import { catcat as cc } from "cerulean";
import { modules } from "byzantine";
import type Account from "byzantine/src/Account";
import { useLocalization } from "@fluent/react";
import { useCopyableText } from "./DirectDepositContainer";

interface RoutingAndAccountNumberCardProps {
  selectedAccount?: Account;
}

const RoutingAndAccountNumberCard = ({
  selectedAccount,
}: RoutingAndAccountNumberCardProps) => {
  const { l10n } = useLocalization();
  const {
    toggleMaskedState,
    formatSensitiveData,
    iconForShowHideButton,
    labelForShowHideButton,
  } = modules.directDeposit.useSensitiveDataDisplay(l10n);

  const {
    onCopyButtonClick: onAccountCopyButtonClick,
    copyButtonLabel: accountCopyButtonClick,
  } = useCopyableText();

  const {
    onCopyButtonClick: onRoutingCopyButtonClick,
    copyButtonLabel: routingCopyButtonClick,
  } = useCopyableText();

  return (
    <LoadingSkeleton isLoading={!selectedAccount}>
      <div className="bgColor--smokeGrey rounded--all--m padding--all--m">
        <Row className="margin--bottom--m">
          <Row.Item>
            <div className="fontColor--secondary fontSize--xs margin--bottom--xxs">
              {l10n.getString("account-detail-routing-number")}
            </div>
            <div className="fontColor--heading fontSize--s">
              {formatSensitiveData(selectedAccount?.routing)}
            </div>
          </Row.Item>
          <Row.Item shrink>
            <Button
              kind="plain"
              label={routingCopyButtonClick}
              size="s"
              onClick={() => {
                onRoutingCopyButtonClick(selectedAccount?.routing);
              }}
            />
          </Row.Item>
        </Row>

        <Row>
          <Row.Item>
            <div className="fontColor--secondary fontSize--xs margin--bottom--xxs">
              {l10n.getString("account-detail-account-number")}
            </div>
            <div className="fontColor--heading fontSize--s">
              {formatSensitiveData(selectedAccount?.number)}
            </div>
          </Row.Item>
          <Row.Item shrink>
            <Button
              kind="plain"
              label={accountCopyButtonClick}
              size="s"
              onClick={() => {
                onAccountCopyButtonClick(selectedAccount?.number);
              }}
            />
          </Row.Item>
        </Row>
      </div>
      <div className="margin--top--m">
        <button
          className="button--reset fontColor--heading fontWeight--semibold alignChild--left--bottom"
          onClick={toggleMaskedState}
        >
          <div
            className={cc("fontSize--l", `narmi-icon-${iconForShowHideButton}`)}
          />
          <div className="margin--left--xs fontSize--s">
            {labelForShowHideButton}
          </div>
        </button>
      </div>
    </LoadingSkeleton>
  );
};

export default RoutingAndAccountNumberCard;
